<template>
  <transition v-if="found" name="fade" mode="out-in" appear>
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  data: () => ({
    found: false
  }),
  beforeMount () {
    this.beforeEnter()
  },
  methods: {
    beforeEnter () {
      let contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      let sections = this.$store.getters.sectionByContent(contentData.key)
      for (let s of sections) {
        if (s.url === this.$route.params.sectionUrl) {
          this.found = true
          return
        }
      }
      const appMsg = {
        type: 'error',
        msg: 'Section not found'
      }
      this.$store.dispatch('showAppMsg', appMsg)
      this.$router.push('/content')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/SectionWrap.vue